import { FILTER_VALUES } from "@/constants/filters";
const monthMap = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12"
};
export const parseAuditLogTimestamp = (timestamp)=>{
    const [datePart] = timestamp.split(":");
    const [day, month, year] = datePart.split("/");
    const time = timestamp.split(" ")[0].split(":").slice(1).join(":");
    const monthValue = monthMap[month] || "01";
    return new Date(`${year}-${monthValue}-${day}T${time}Z`);
};
export const getAuditLogStatusColor = (status)=>{
    if (status >= 200 && status < 300) return "bg-green-100 text-green-800";
    if (status >= 300 && status < 400) return "bg-blue-100 text-blue-800";
    if (status >= 400 && status < 500) return "bg-yellow-100 text-yellow-800";
    return "bg-red-100 text-red-800";
};
const statusTextMap = {
    200: "OK",
    201: "Created",
    204: "No Content",
    400: "Bad Request",
    401: "Authorization Failed",
    403: "Forbidden",
    404: "Not Found",
    429: "Rate Limited",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable"
};
export const getStatusText = (status)=>{
    return statusTextMap[status] || `Status ${status}`;
};
export const formatGeography = (city, countryCode)=>{
    if (!city) return "-";
    if (!countryCode) return city;
    return `${city} (${countryCode})`;
};
const methodColors = {
    GET: "bg-blue-100 text-blue-800",
    POST: "bg-green-100 text-green-800",
    PUT: "bg-yellow-100 text-yellow-800",
    DELETE: "bg-red-100 text-red-800",
    PATCH: "bg-purple-100 text-purple-800"
};
export const getAuditLogMethodColor = (method)=>{
    return methodColors[method] || "bg-gray-100 text-gray-800";
};
export const filterAuditLogsByProduct = ({ logs, selectedApiKey, selectedProduct, apiKeys })=>{
    if (selectedApiKey !== FILTER_VALUES.ALL) {
        return logs;
    }
    if (selectedProduct === FILTER_VALUES.ALL) {
        return logs;
    }
    if (!apiKeys?.length) {
        return [];
    }
    const productApiKeyIds = new Set(apiKeys.map((key)=>key.id));
    return logs.filter((log)=>productApiKeyIds.has(log.apiKeyId));
};
